import {
  UseAndCareVideoResponse,
  UseAndCareVideosModel
} from '../../interface/support-and-service';
import { DropdownOptionType } from '../../types/dropdown';
import { MetaPages } from '../../enums/pages';
import { ContentType } from '../../types/content';
import {
  getSupportAndServiceHeader,
  getUseAndCareVideos,
  getBrandDropdownOptions,
  getCategoryDropdownOptions
} from '../../services/support-and-service';
import SectionContainer from '../../components/atoms/section-container/section-container';
import UseAndCareVideoContainer from '../../components/atoms/use-and-care-video-container/use-and-care-video-container';
import HeaderContainer from '../../components/molecules/header-container/header-container';
import Tabs from '../../components/molecules/tabs/tabs';
import Dropdown from '../../components/atoms/dropdown/dropdown';
import { supportAndServiceRoutes } from '../../config/routes/pages';
import { useUseAndCareVideosFilter } from '../../hooks/useUseAndCareVideosFilter';
import TabTitle from '../../components/atoms/tab-title/tab-title';

type UseAndCareVideoProps = {
  brandDropdownOptions: DropdownOptionType[];
  categoryDropdownOptions: DropdownOptionType[];
  supportAndServiceHeader: ContentType;
  useAndCareVideos: UseAndCareVideoResponse;
};

export function Index(props: UseAndCareVideoProps) {
  const {
    brandDropdownOptions,
    categoryDropdownOptions,
    supportAndServiceHeader,
    useAndCareVideos
  } = props;

  const { data: useAndCareVideosData } = useAndCareVideos;

  const {
    filteredDropdownOptions,
    filteredUseAndCareVideos,
    setBrandFilter,
    setCategoryFilter
  } = useUseAndCareVideosFilter(categoryDropdownOptions, useAndCareVideosData);

  function handleSelectBrand(brand: string) {
    setBrandFilter(brand);
  }

  function handleSelectCategory(category: string) {
    setCategoryFilter(category);
  }

  const videoNames = filteredUseAndCareVideos.map(
    (video) => video.attributes.Title
  );

  const filterDuplicateVideos = filteredUseAndCareVideos.filter(
    (video, index) => !videoNames.includes(video.attributes.Title, index + 1)
  );

  const renderUseAndCareVideos = filterDuplicateVideos?.map(
    (useAndCareVideo: UseAndCareVideosModel) => {
      return (
        <UseAndCareVideoContainer
          key={useAndCareVideo.id}
          {...useAndCareVideo.attributes}
        />
      );
    }
  );

  return (
    <div>
      <TabTitle page={MetaPages.USE_AND_CARE_VIDEOS} />
      <HeaderContainer {...supportAndServiceHeader} />
      <Tabs tabItems={supportAndServiceRoutes} />
      <SectionContainer>
        <div className="space-y-4 text-center">
          <p className="text-header5 lg:text-header4 uppercase">
            Use and Care Videos
          </p>
          <p className="text-subtitle">
            Maximize the kitchen potentials of your Sub-Zero and Wolf appliances
            with these tutorial videos.
          </p>
        </div>
        <div className="flex justify-center pt-4 space-x-2 px-4">
          <Dropdown
            onSelect={(brand: string) => handleSelectBrand(brand)}
            options={brandDropdownOptions}
          />
          <Dropdown
            onSelect={(category: string) => handleSelectCategory(category)}
            options={filteredDropdownOptions}
          />
        </div>

        <div className="grid lg:grid-cols-2 gap-4 mt-12 md:px-48 lg:p-4">
          {renderUseAndCareVideos}
        </div>
      </SectionContainer>
    </div>
  );
}

export async function getStaticProps() {
  const brandDropdownOptions = await getBrandDropdownOptions();
  const categoryDropdownOptions = await getCategoryDropdownOptions();
  const supportAndServiceHeader = await getSupportAndServiceHeader();
  const useAndCareVideos = await getUseAndCareVideos();

  return {
    props: {
      brandDropdownOptions,
      categoryDropdownOptions,
      supportAndServiceHeader,
      useAndCareVideos
    }
  };
}

export default Index;
